module.exports = __webpack_public_path__ + "assets/icons/ic_clear_24px.svg";